import React, { useState } from 'react';
import { BodyText, Button, FlexContainer, FlexItem } from '@placer-ui/components';
import { RequestPropertyFormProps } from 'features/my-zone/support-requests/components/support-requests-modals/modals/request-new-location/request-property/types';
import { SendSupportCSOwnerEmail } from 'features/my-zone/support-requests/components/support-requests-modals/modals/request-new-location/request-property/flow-config/support-request-results-modal/components/ask-for-review/components/send-support-cs-owner-email/send-support-cs-owner-email';

export const ReasonForSensitiveLocation = ({ item, onNextHandler }: RequestPropertyFormProps) => {
    const [isAskQuestionMode, setIsAskQuestionMode] = useState(false);

    return (
        <FlexContainer flexDirection="column" gap={16} height="100%" style={{ overflow: 'auto' }}>
            <FlexContainer flexDirection="column" gap={16} height="100%">
                {!isAskQuestionMode && (
                    <BodyText>
                        This property is in a restricted area per Placer’s policy. Learn more on the
                        Trust Center.
                    </BodyText>
                )}

                {isAskQuestionMode && (
                    <SendSupportCSOwnerEmail onNextHandler={onNextHandler} entity={item} />
                )}
            </FlexContainer>

            {!isAskQuestionMode && (
                <FlexItem alignSelf="flex-end">
                    <FlexContainer gap="8px">
                        <Button
                            onClick={() => setIsAskQuestionMode(true)}
                            testId="sensitive-location-request-button"
                            variant="secondary-gray"
                            size="small"
                        >
                            I Have a Question
                        </Button>

                        <Button
                            onClick={() => {
                                window.open('https://www.placer.ai/company/trust-center', '_blank');
                                onNextHandler?.();
                            }}
                            testId="sensitive-location-trust-center-button"
                            variant="primary-gray"
                            size="small"
                        >
                            Trust Center
                        </Button>
                    </FlexContainer>
                </FlexItem>
            )}
        </FlexContainer>
    );
};
